  <!-- HEADER START -->
<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title color="secondary" class="ion-text-center header-title">{{ 'MY_BOOKINGS.TITLE' | translate }}</ion-title>
      <ion-buttons slot="start" class="header-buttons">
        <ion-back-button color="secondary" defaultHref="/"></ion-back-button>
      </ion-buttons>
      <!--<ion-buttons slot="start" class="header-buttons" style="margin-left:-6px">
        <ion-button [routerLink]="['/']" class="header-buttons__btn">
          <ion-icon name="arrow-back-sharp" slot="icon-only" shape="round" ></ion-icon>
        </ion-button>
      </ion-buttons>-->

      <app-top-right slot="end"></app-top-right>

    </ion-toolbar>
  </ion-grid>
</ion-header>
<!-- HEADER END -->

<ion-content class="bookings">
  <ion-grid fixed class="ion-no-padding">
  <ion-list class="bookings--reserved" *ngIf="activeBookings$|async as activeBookings">
    <ion-item [routerLink]="[ './' + booking.id ]" *ngFor="let booking of activeBookings?.items" lines="none" class="bookings--reserved__item active" no-padding>
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col size="3" class="ion-align-self-start img-wrap">
            <ion-img [src]="( booking.getShopImage() | ppImage )"></ion-img>
          </ion-col>
          <ion-col size="9">
            <p class="bookings--reserved__item-shop">{{ booking.getShopName() }} 
              <ion-badge *ngIf="booking.status == 10" class="ion-float-right" style="border-radius:0;" color="warning">{{ 'MY_BOOKINGS.CONFIRMATION_PENDING' | translate }}</ion-badge>
              <ion-badge *ngIf="booking.status == 20 && ( !booking.paymentRequired || booking.paid ) && ( !booking.noShowProtection || booking.noShowProtected )" class="ion-float-right" style="border-radius:0;" color="success">{{ 'MY_BOOKINGS.CONFIRMED' | translate }}</ion-badge><ion-badge *ngIf="booking.paymentRequired && !booking.paid" class="ion-float-right" style="border-radius:0;" color="danger">{{ 'MY_BOOKINGS.PAYMENT_MISSING' | translate }}</ion-badge><ion-badge *ngIf="booking.paymentRequired && booking.paid" class="ion-float-right" style="border-radius:0;" color="success">{{ 'MY_BOOKINGS.PAYED' | translate }}</ion-badge>
              <ion-badge *ngIf="booking.noShowProtection && !booking.noShowProtected" class="ion-float-right" style="border-radius:0;" color="danger">{{ 'MY_BOOKINGS.NO_SHOW_PROTECTION_MISSING' | translate }}</ion-badge>
               <!--ion-badge *ngIf="booking.noShowProtection && booking.noShowProtected" class="ion-float-right" style="border-radius:0;" color="success">{{ 'MY_BOOKINGS.NO_SHOW_PROTECTED' | translate }}</ion-badge-->

            </p>
            <ion-icon class="arrow-right"></ion-icon>
            <p class="bookings--reserved__item-address">{{ booking.getRootReal().address }}</p>
            <p class="bookings--reserved__item-date">{{ booking.start | momentDate:"fullDate":undefined:translateService.currentLang | titlecase }}</p>
            <p class="bookings--reserved__item-time">za {{ booking.partySize}} {{ booking.partySize | i18nPlural : { '=1': 'osebo', '=2': 'osebi', '=3': 'osebe', '=4': 'osebe', 'other': 'oseb'} }}, {{ 'MY_BOOKINGS.START_AT' | translate }} <span class="bold">{{ booking.start | momentDate:"shortTime" }}</span></p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>
  </ion-list>


  <ng-container *ngIf="archiveBookings$|async as archiveBookings">
  
  <ion-item-divider mode="md">
    <ion-label class="bookings-divider">{{ 'MY_BOOKINGS.HISTORY' | translate }}</ion-label>
  </ion-item-divider>


  <ion-list class="bookings--history" mode="md" lines="none">
    <ion-item [routerLink]="[ './' + booking.id ]" *ngFor="let booking of archiveBookings?.items" [ngClass]="{'canceled-v2': booking.canceled}" class="bookings--history__item" no-padding>
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col size="3" class="ion-align-self-start img-wrap">
            <ion-img [src]="( booking.getShopImage() | ppImage )"></ion-img>
          </ion-col>
          <ion-col size="9">
            <p class="bookings--history__item-shop">{{ booking.getShopName() }}<span *ngIf="booking?.onBehalfOfName"> {{booking.onBehalfOfName}}</span></p>
            <ion-icon class="arrow-right"></ion-icon>
            <p class="bookings--history__item-address">{{ booking.getRootReal().address }}</p>
            <p class="bookings--history__item-date">{{ booking.start | momentDate:"fullDate":undefined:translateService.currentLang | titlecase }}</p>
            <p class="bookings--history__item-time">{{ 'MY_BOOKINGS.START_AT' | translate }} <span class="bold">{{ booking.start | momentDate:"shortTime" }}</span></p>
            <!--<p class="bookings--history__item-reserve">
              <a class="pp-link">rezerviraj ponovno</a>
            </p>-->
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-item>
  </ion-list>

  </ng-container>
  </ion-grid>
</ion-content>